import * as React from 'react';
import type { ValidationPropType } from './use-validation';
import { useGenericField } from './text';

export type SelectboxFieldPropType = ValidationPropType;

export function useSelectBox(
  inputRef: React.RefObject<HTMLSelectElement | null>,
  { error, validate }: ValidationPropType = {},
) {
  return useGenericField(inputRef, { error, validate });
}
